// extracted by mini-css-extract-plugin
export default {"container":"PhoneInput_container__lVshM"};